import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import capitalMarketsService from '../services/capitalMarketsService';

export default function useRemoveFromBlocklist() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ccb: string) => capitalMarketsService.removeFromBlocklist(ccb),
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || 'Erro ao remover financiamento da lista de bloqueios';
      toast.error(errorMessage);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['financing-blocklist'] });
      toast.success(data.message || 'Financiamento removido da lista de bloqueios com sucesso');
    },
  });
}
